import sanctum from '../../http/requests/auth/sanctum';

export default {
  create: {
    type: '',
    typeLists: [{
        type: 'inbox',
        title: 'Surat Masuk',
        subtitle: 'Menerima surat dari instansi lain',
        icon: '/images/mails/inbox.svg',
        to: '/surat/buat/masuk',
        isShow: sanctum.canCreateSuratMasuk(),
      },
      {
        type: 'outbox',
        title: 'Surat Keluar',
        subtitle: 'Mengirim surat ke instansi lain',
        icon: '/images/mails/outbox.svg',
        to: '/surat/buat/keluar',
        isShow: true,
      },
    ],
  },

  edit: {
    type: null,
    id: null,
  },

  settingSurat: {
    isActive: false,
    showFormSignature: false,
    suratId: ''
  },

  showSurat: {
    isActive: false,
    showFormSignature: false,
    suratId: ''
  },

  detail: {
    id: null,
  },
};
